import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchCountries({ params }, callbacks) {
  try {
    const response = yield call(api.fetchCountries, params);
    yield put(Actions.fetchCountriesSuccess(response?.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks?.success, response?.data);
    }
  } catch (error) {
    yield put(Actions.fetchCountriesFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks?.failure, error);
    }
  }
}

function* watchFetchCountries() {
  yield takeLatest(Actions.FETCH_COUNTRIES_REQUEST, fetchCountries);
}

export default function* list() {
  yield all([fork(watchFetchCountries)]);
}
